// extracted by mini-css-extract-plugin
export default {"container":"input-age_container__ywV86","label":"input-age_label__+gjhc","errorLabel":"input-age_errorLabel__G8Iiu","errorInput":"input-age_errorInput__Se8kB"};